// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"classes_Paragraph__2waE7","lastInput":"classes_lastInput__2jKo1","disabled":"classes_disabled__2bdkz"};